export const QUERY_KEYS = {
    LOCATIONS: ['locations'] as const,
    MATERIAL_DEFINITIONS: ['material-definitions'] as const,
    MATERIAL_DEFINITIONS_ID: (id: string) => ['material-definitions', id] as const,
    DEVICE_TYPES: ['device-types'] as const,
    TESTS: ['tests'] as const,
    TRAINING_PROGRAMS_INFO: ['training-programs-info'] as const,
    CUSTOM_FIELDS: ['custom-fields'] as const,
    ALARMS: ['alarms'] as const,
    CUSTOM_ALARM_DEFINITION_ID: (id: string) => ['custom-alarm-definition', id] as const,
    REGISTERED_EVENTS_DEVICE_TYPE_ID: (deviceTypeId: string) => ['registered-events', deviceTypeId] as const,
} as const;
